import React, { useEffect, useState,useRef } from "react";
import "../Home/Home.css";

import "./CardDetail.css";
import axios from "../../services/axios";

import logoFb from "../../assets/img/rrss/fb.svg";
import logoTwit from "../../assets/img/rrss/twitter.svg";
// import logoTube from "../../assets/img/rrss/youtube.svg";
// import logoInsta from "../../assets/img/rrss/insta.svg";
import logoPint from "../../assets/img/rrss/pinterest.svg";
import logoEmail from "../../assets/img/rrss/mail.svg";
import linked from "../../assets/img/rrss/linkedin.svg";
import renderHTML from "react-render-html";
import { useHistory } from "react-router-dom";

import PlayerMaterial from '../PlayerMaterial/PlayerMaterial';
import PlayerShow from "../PlayerShow/PlayerShow";
import ReactPlayer from 'react-player';

import moment from 'moment';

//modals to show solictud de visionado 
import { RequestVisionModal } from "../RequestVisionModal/RequestVisionModal";
//modals to show solictud de visionado expired 
import { RequestVisionExpiredModal } from "../RequestVisionExpiredModal/RequestVisionExpiredModal";


//modals to show share link
import {ShareVisionModal} from "../ShareVisionModal/ShareVisionModal";

//modals to show vision/download
import {VisionDownloadModal} from "../VisionDownloadModal/VisionDownloadModal";
//modals to show vision/download
import {VisionDownloadIntermediateModal} from "../VisionDownloadIntermediateModal/VisionDownloadIntermediateModal";

//pending download modal
import {PendingDownloadModal} from "../PendingDownloadModal/PendingDownloadModal";
//accepted download modal
import {AcceptedDownloadModal} from "../AcceptedDownloadModal/AcceptedDownloadModal"; 

function CardDetail(props) {
  const history = useHistory();
  const openTrailer=(assetId) =>{
    
    history.push('/trailer/'+assetId);
   // window.open('/trailer/'+assetId);
  
  }
  const openShow=(assetId) =>{
    history.push('/player/'+assetId);
   // window.open('/trailer/'+assetId);
  
  }
  const {
    autor,
    description,
    duration,
    eventDetail,
    gender,
    posterUrl,
    staff,
    subtitle,
    thirdPartyId,
    // thirdPartyURLPlayer,
    title,
    trailer,
    poster_opac,
    recommendedAge,
    subtitleList,
    idiomList,
    webPublicUrl,
    assetId,
    relatedContentList,
    materialUrl,
    showEvent,
    showButtonPlay,
    seasonName
  } = props.info;

  //etiquetas idiomas
  const lang = props.lang;
  let buy,
    subs,
    share,
    trailerEti,
    langs,
    linkSub,
    linkBuy,
    shareText,
    and,
    extra,
    texts = "",
    content;
  //opacidad del poster desde DAM
  const style = {
    opacity: poster_opac,
  };

  //Koobin
  const [hasTicket, setTicket] = useState(false);
  const [hasSubs, setSubs] = useState(false);
  const [isLogged, setLogged] = useState(false);


//visionRequestModal Profesor
const ref = useRef();
const [showModal, setShowModal] = useState(false);
const openModal = () => {
  //check if vision is expired
  console.log('check visionStatus::->'+visionStatus);
  if(!visionStatus)
  {
    setShowModal((prev) => !prev);
  }//check if vision is not expired
  if(visionStatus && visionStatus==='EXPIRED' )
  {
    //if is expired show new  modal
    // if not expired shw old modal
    setShowModal5((prev) => !prev);
  }

 
  
};
const [showVisionButton,setShowVisionButton]= useState(false);
const [showShareButton,setShowShareButton]=useState(false);
const [showEducationButtonPlay,setShowEducationButtonPlay]=useState(false);

//etiqueta modulo educativo
let requestViewLabel;
let requestDownLoadLabel;
let shareForGroupsLabel;
let requestPendingLabel;
let requestAcceptedLabel;
let registerLabel;
//etiqueta modulo educativo

const openRegister = () => {
  //alert('enviar a koobin::'+window.location.href);
  let arry=window.location.href;
  let arrayParam=arry.split("/");
  console.log(arry.split("/"));
  let assetIdAux=arrayParam[arrayParam.length-1];
  console.log('elemento a enviar::'+assetIdAux);
  let linkdirect='https://tncdigital.cat/educatiuprofessionals/response/eventId='+assetIdAux;
 window.open('https://entrades.tnc.cat/ca/zona-personal?referer=YGdgYHBicHxzUXdldklrd3JrcW5nSSon&_ga=2.208724498.1625584138.1630812427-24462051.1630105010&rd='+encodeURI(linkdirect));
};



const accepteVisionTerm = async (motivo)=>
{
   // parameters from modal
    //call service to register in damcloud
    let res = false;
      const params = {
        eventId: thirdPartyId,
        tokenKoobin: localStorage.getItem("token"),
        rol:localStorage.getItem("rol"),
        motive:motivo
      };
      try {
        // res = await axios.post(`http://15.237.23.231:8020/damcloudtaservice/rest/meta/educationservice/visionrequest`, params);
        res = await axios.post(`https://tncdigital.cat/damcloudservicetnceducativo/rest/meta/educationservice/visionrequest`, params);
     
        if (res.data) {
          //const resp = res.data.hasTicketFor;

          //setTicket(resp);
          // localStorage.setItem("expirationDate", res.data.expirationDate);
          // localStorage.setItem("hasMemberShips", res.data.hasMemberships);
          // localStorage.setItem("token", res.data.accessToken);
          // localStorage.setItem("email", email);
        }
      } catch (err) {
        console.log("Error calling service::", err);
      }
    //end call service to register in damcloud
    //show compartement groups  si rol es profesor
    //call check user service
    //hide  button solitat vision.
    setShowVisionButton(false);
    setShowShareButton(true);
    setShowEducationButtonPlay(true);
    // close modal
    setShowModal(false);
}
// end visionRequestModal Profesor

//visionRequestExpiredModal
const refVisionRequestExpiredModal=useRef();
const [showModal5, setShowModal5] = useState(false);

//end visionRequestExpiredModal
const refShareVisionModal=useRef();
const [showModal2, setShowModal2] = useState(false);
const[shareLink,setShareLink]=useState('');
const[shareLinkDateExpired,setShareLinkDateExpired]=useState('');
const[visionStatus,setVisionStatus]=useState('');
const openShareLinkModal = async() => {
  //call service check user.
  let res = false;
      const params = {
        eventId: thirdPartyId,
        tokenKoobin: localStorage.getItem("token"),
        rol:localStorage.getItem("rol")
      };
      try {
        //res = await axios.post(`http://15.237.23.231:8020/damcloudtaservice/rest/meta/educationservice/checkuserservice`, params);
        res = await axios.post(`https://tncdigital.cat/damcloudservicetnceducativo/rest/meta/educationservice/checkuserservice`, params);
     
        /*persist in local storage*/
        if (res.data) {
          //pass  data to modal
          //const resp = res.data.hasTicketFor;
          setShareLink(res.data.visionLink);
           //convert to local time
           let localtime=moment.utc(res.data.dateLinkExpired).toDate();
           localtime=moment(localtime).format('YYYY-MM-DD HH:mm:ss');
           console.log('local time convert utc time::'+localtime);
          setShareLinkDateExpired(localtime);
         
         // setTicket(resp);
          // localStorage.setItem("expirationDate", res.data.expirationDate);
          // localStorage.setItem("hasMemberShips", res.data.hasMemberships);
          // localStorage.setItem("token", res.data.accessToken);
          // localStorage.setItem("email", email);
        }
      } catch (err) {
        console.log("Error calling service::", err);
      }
  //end call service check user.
  
  setShowModal2((prev) => !prev);
};
//download request modal
const refVisionDownloadModal=useRef();
const [showDownloadRequest, setShowDownloadRequest] = useState(false);
const [showDownloadRequestStatePending, setShowDownloadRequestStatePending] = useState(false);
const [showDownloadRequestStateAccepted, setShowDownloadRequestStateAccepted] = useState(false);
const [showModal3, setShowModal3] = useState(false);
const [showModal4, setShowModal4] = useState(false);
const openModal3 = () => {
  console.log('open modal 3')
  setShowModal3((prev) => !prev);
};
const accepteDownloadTerm = async (motivo)=>
{
    console.log('acepted download term');
    //call service to register in damcloud
    let res = false;
      const params = {
        eventId: thirdPartyId,
        tokenKoobin: localStorage.getItem("token"),
        rol:localStorage.getItem("rol"),
        motive:motivo
      };
      try {
       // res = await axios.post(`http://15.237.23.231:8020/damcloudtaservice/rest/meta/educationservice/downloadrequest`, params);
       res = await axios.post(`https://tncdigital.cat/damcloudservicetnceducativo/rest/meta/educationservice/downloadrequest`, params);
    
        /*persist in local storage*/
        if (res.data) {
          //const resp = res.data.hasTicketFor;

          //setTicket(resp);
          // localStorage.setItem("expirationDate", res.data.expirationDate);
          // localStorage.setItem("hasMemberShips", res.data.hasMemberships);
          // localStorage.setItem("token", res.data.accessToken);
          // localStorage.setItem("email", email);
        }
      } catch (err) {
        console.log("Error calling service::", err);
      }
    //end call service to register in damcloud
    //call check user service
    //hide  button solitat descarga.
    setShowDownloadRequest(false);
    setShowDownloadRequestStatePending(true);
    setShowDownloadRequestStateAccepted(false);
    // close modal
    setShowModal3(false);
}
//end download request modal
//download request intermediate modal
const refVisionDownloadIntermediateModal=useRef();
const openModal4 = () => {
  console.log('open modal 4')
  setShowModal4((prev) => !prev);
};
const accepteDownloadIntermediateTerm = async (action)=>
{
  if(action ==='vision')
  {
    console.log('Action intermediate modal-->'+action);
    console.log('Vision Estatus-->'+visionStatus)
    setShowModal4((prev) => !prev);//modal intermedio se oculta
    if(visionStatus ==='EXPIRED')
    {
        //show modal visionExpired
        setShowModal5((prev) => !prev);//modal expired se muestra
    }
    if(!visionStatus)
    {
      setShowModal((prev) => !prev);//modal para solicitar visionado
    }
    

  }
 if (action ==='download') {
  console.log('Action intermediate modal-->'+action);
  setShowModal4((prev) => !prev);
  setShowModal3((prev) => !prev);//modal para descarga
  }
    
}
//end download intermediate modal

// pending modal
const refPendingDownloadModal=useRef();
const [showPendingDownload, setShowPendingDownload] = useState(false);
const openPendingDownloadModal = () => {
  setShowPendingDownload(true);
};

//end pending modal

//accepted modal
const refAcceptedDownloadModal=useRef();
const [showAcceptedDownload, setShowAcceptedDownload] = useState(false);
const openAcceptedDownloadModal = () => {
  setShowAcceptedDownload(true);
};



  /*useEffect(() => {
    window.scroll(0, 0);
  }, []);*/
  useEffect( () => {
    setLogged(props.isLogged);
    //call check user when user logged or not
    if(props.isLogged ===true)
    {
        //is logged, so checkuserstate
        console.log('check user estate');
        let res;
        async function fetchUser()
        {
        const params = {
          eventId: thirdPartyId,
          tokenKoobin: localStorage.getItem("token"),
          rol: localStorage.getItem("rol"),
        };
        try {
          res = await axios.post(`https://tncdigital.cat/damcloudservicetnceducativo/rest/meta/educationservice/checkuserservice`, params);
          //res = await axios.post(`http://15.237.18.108:9050/damcloudtaservice/rest/meta/educationservice/checkuserservice`, params);

         //res = await axios.post(`http://15.237.23.231:8020/damcloudtaservice/rest/meta/educationservice/checkuserservice`, params);

          /*persist in local storage*/
          if (res.data) {
            console.log('updates buttons to show::'+res.data.showVisionButton);

            if(res.data.visionStatus)//si existe status
            {
              setVisionStatus(res.data.visionStatus);
            }
            if(!res.data.visionStatus)//si no existe status poner vacio
            {
             
              setVisionStatus('');
              setShowVisionButton(true);
            }
            if( res.data.visionStatus && res.data.visionStatus ==='ACTIVE')//si existe link
            {
             
              setShowVisionButton(false);
            }
            if( res.data.visionStatus && res.data.visionStatus ==='EXPIRED')//si existe link
            {
             
              setShowVisionButton(true);
            }



           
            setShowShareButton(res.data.showShareButton);
            setShowEducationButtonPlay(res.data.showEducationButtonPlay);

            //for profesional
            setShowDownloadRequest(res.data.showDownloadRequest);
            setShowDownloadRequestStatePending(res.data.showDownloadRequestStatePending);
            setShowDownloadRequestStateAccepted(res.data.showDownloadRequestStateAccepted);


            //pass  data to modal          
           // setTicket(resp);
            // localStorage.setItem("expirationDate", res.data.expirationDate);
            // localStorage.setItem("hasMemberShips", res.data.hasMemberships);
            // localStorage.setItem("token", res.data.accessToken);
            // localStorage.setItem("email", email);
          }
        } catch (err) {
          console.log("Error calling service::", err);
        }
      }
      fetchUser();  


    }
  }, [props.isLogged]);

  //compartir
  const link = window.location.href;

  //LANGS
  if (lang === "cat") {
    extra = "Material complementari";
    share = "Compartir";
    langs = "Idioma";
    texts = "Subtítols";
    buy = "Entrada 1 espectacle 5 €";
    subs = "Subscripció temporada 29 €";
    linkBuy = `https://entrades.tnc.cat/index.php?action=PU_evento&streamingId=${thirdPartyId}`;
    linkSub = "https://entrades.tnc.cat/ca/mes-productes?Ex_id=32";
    shareText = `Comparteixo aquesta obra ${title} ${link}`;
    trailerEti = "Tràiler";
    and = "i";
    content='Contingut Relationat';
    //add button label
    requestViewLabel="Sol·licitar visionat";
    requestDownLoadLabel="Sol·licitar descàrrega";
    shareForGroupsLabel="Compartir per a grups";
    requestPendingLabel="Sol·licitud pendent";
    requestAcceptedLabel="Sol·licitud acceptada";
    registerLabel="Identifica't o Registra't";
  }
  if (lang === "esp") {
    extra = "Material complementario";
    share = "Compartir";
    langs = "Idioma";
    texts = "Subtítulos";
    buy = "Entrada 1 espectáculo 5 €";
    subs = "Subscripción temporada 29 €";
    linkSub = " https://entrades.tnc.cat/es/mas-productos?Ex_id=32";
    linkBuy = `https://entrades.tnc.cat/es/index.php?action=PU_evento&streamingId=${thirdPartyId}`;
    trailerEti = "Trailer";
    and = "y";
    content='Contenido Relacionado';
    //add button label
    requestViewLabel="Solicitar visionado";
    requestDownLoadLabel="Solicitar descarga";
    shareForGroupsLabel="Compartir a grupos";
    requestPendingLabel="Solicitud de descarga registrada";
    requestAcceptedLabel="Solicitud de descarga aprobada";
    registerLabel="Identíficate o regístrate";
  }
  if (lang === "eng") {
    share = "Share";
    langs = "Language";
    texts = "Subtitles";
    buy = "1 performance ticket 5 €";
    subs = "Season sign up 29 €";
    linkSub = "https://entrades.tnc.cat/en/more-products?Ex_id=32";
    linkBuy = `https://entrades.tnc.cat/en/index.php?action=PU_evento&streamingId=${thirdPartyId}`;
    trailerEti = "Trailer";
    extra = "Extras";
    and = "and";
    content='Related Content';
    //add button label
     requestViewLabel="Request viewing";
     requestDownLoadLabel="Request download";
     shareForGroupsLabel="Share url for teachers";
     requestPendingLabel="Download request registered";
     requestAcceptedLabel="Download request approved";
     //add message label
     registerLabel="Identify yourself or register";


  }

  //COMPROBACION USUARIO KOOBIN

  useEffect(() => {
    const sendTicketRequest = async () => {
      let res = false;
      const params = {
        eventId: thirdPartyId,
        tokenKoobin: localStorage.getItem("token"),
      };
     /* try {
        res = await axios.post(`/hasTicketFor`, params);
      
        if (res.data) {
          const resp = res.data.hasTicketFor;

          setTicket(resp);
        }
      } catch (err) {
        console.log("Error calling service::", err);
      }*/
    };
    //check si tiene hasMemberShip
    //GetItem de local
    if (isLogged) {
      const hasMemberShip = localStorage.getItem("hasMemberShips");

      if (hasMemberShip === "false") {
        //si no tiene, comprobación si la tiene comprada,
        sendTicketRequest();
      }
      if (hasMemberShip === "true") {
        setSubs(true);
        setTicket(true);
      }
    } else {
      setTicket(false);
    }

    //si no tiene esta obra petición con thirdPartyId
    //si no tiene esta obra pero tiene otras
    //test if exist token in context validate to damcloud service

    //call check user when thirdPartyId changes
    if (isLogged === true)
    {
        //call service to check assetId for education service
        console.log('check user for education service');

    }
    //en call check user when thirdPartyId changes

  }, [isLogged, thirdPartyId]);

  const handleBuy = () => {};

  

  return (
    <>
     <div ref={ref}>
        <RequestVisionModal
          showModal={showModal}
          setShowModal={setShowModal}
          lang={lang}
          isLoggedFunc={props.isLoggedFunc}
          accepteVisionTerm={accepteVisionTerm}
          // movie={assetIdTest}
        ></RequestVisionModal>
      </div>
      <div ref={refVisionRequestExpiredModal}>
        <RequestVisionExpiredModal
          showModal={showModal5}
          setShowModal={setShowModal5}
          lang={lang}
          isLoggedFunc={props.isLoggedFunc}
          accepteVisionTerm={accepteVisionTerm}
          // movie={assetIdTest}
        ></RequestVisionExpiredModal>
      </div>
      <div ref={refShareVisionModal}>
        <ShareVisionModal
          showModal={showModal2}
          setShowModal={setShowModal2}
          lang={lang}
          isLoggedFunc={props.isLoggedFunc}
          shareLink={shareLink}
          shareLinkDateExpired={shareLinkDateExpired}
          // movie={assetIdTest}
        ></ShareVisionModal>
      </div>
     <div ref={refVisionDownloadModal}>
        <VisionDownloadModal
          showModal={showModal3}
          setShowModal={setShowModal3}
          lang={lang}
          isLoggedFunc={props.isLoggedFunc}
          accepteDownloadTerm={accepteDownloadTerm}
          // movie={assetIdTest}
        ></VisionDownloadModal>
      </div>
      <div ref={refVisionDownloadIntermediateModal}>
        <VisionDownloadIntermediateModal
          showModal={showModal4}
          setShowModal={setShowModal4}
          lang={lang}
          isLoggedFunc={props.isLoggedFunc}
          accepteDownloadIntermediateTerm={accepteDownloadIntermediateTerm}
          visionStatus={visionStatus}
          // movie={assetIdTest}
        ></VisionDownloadIntermediateModal>
      </div>
      <div ref={refPendingDownloadModal}>
        <PendingDownloadModal
          showModal={showPendingDownload}
          setShowModal={setShowPendingDownload}
          lang={lang}
          isLoggedFunc={props.isLoggedFunc}
          accepteDownloadTerm={accepteDownloadTerm}
          // movie={assetIdTest}
        ></PendingDownloadModal>
      </div>
      <div ref={refAcceptedDownloadModal}>
        <AcceptedDownloadModal
          showModal={showAcceptedDownload}
          setShowModal={setShowAcceptedDownload}
          lang={lang}
          isLoggedFunc={props.isLoggedFunc}
          accepteDownloadTerm={accepteDownloadTerm}
          // movie={assetIdTest}
        ></AcceptedDownloadModal>
      </div>
   
     
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-M6D7GN"
  height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
  
      <section id="top" className="poster">
        <img
          src={`${posterUrl}`}
          alt={`Foto de ${title}`}
          className="poster__image"
        ></img>
        <div className="poster__poster__opac" style={style}></div>
        <div className="poster__texts">
          <div>
            <p className="poster__texts__title">{title && renderHTML(title.replace(/<[^>]*>/g, ''))}</p>
            <p className="poster__texts__subtitle">{subtitle && renderHTML(subtitle)}</p>
            <p className="poster__texts__autor">{autor && renderHTML(autor)}</p>
          </div>
          <div className="poster__buttons">
          {isLogged === false ? (
              <a  className="poster__button"  >
                <p onClick={()=> openRegister()}> {registerLabel}</p>
              </a>
            ) : (
              <></>
            )}
            {isLogged === true && showVisionButton === true ?  (
              <a  className="poster__button" onClick={() => openModal()} >
                <p>{requestViewLabel}</p>
              </a>
            ) : (
              <></>
            )}
             {isLogged === true && showDownloadRequest === true ? (
              <a  className="poster__button" onClick={() => openModal4()} >
                <p>{requestDownLoadLabel}</p>
              </a>
            ) : (
              <></>
            )}
             {isLogged === true && showDownloadRequestStatePending === true ? (
              <a  className="poster__button" onClick={() => openPendingDownloadModal()}  >
                <p>{requestPendingLabel}</p>
              </a>
            ) : (
              <></>
            )}
              {isLogged === true && showDownloadRequestStateAccepted === true ? (
              <a  className="poster__button"  onClick={() => openAcceptedDownloadModal()}  >
                <p>{requestAcceptedLabel}</p>
              </a>
            ) : (
              <></>
            )}
            {isLogged === true && showShareButton === true  ? (
              <a  className="poster__button" onClick={() => openShareLinkModal()} >
                <p>{shareForGroupsLabel}</p>
              </a>
            ) : (
              <></>
            )}
           {/* {hasSubs === false ? (
              <a href={linkSub} className="poster__button">
                <p>{subs}</p>
              </a>
            ) : (
              <></>
            )}*/}
            {isLogged === true && webPublicUrl != null ? (
             showEducationButtonPlay && <> <a className="poster__button" onClick={() => openShow(assetId)}>
                <i className="fas fa-play"></i>
                <p>Play</p>
              </a>
              </>
            ) : (
              <></>
            )}
           {/* {hasTicket === false && webPublicUrl ? (
              <a
                href={linkBuy}
                onClick={handleBuy}
                className="poster__button entrades"
              >
                <p>{buy}</p>
              </a>
            ) : (
              <></>
            )}
            */}

            {trailer ? (
              <a  className="poster__button" onClick={() => openTrailer(assetId)}>
                <p>{trailerEti}</p>
              </a>
            ) : null}
          </div>
        </div>
      </section>
      <section className="container__section">
        <div className="container">
          <div className="item-left">
            <p className="item-left-title">{eventDetail && renderHTML(eventDetail.replace(/<[^>]*>/g, ''))}</p>
            <p className="item-left-description">{description && renderHTML(description)}</p>
          </div>
          <div className="item-right">
            <div className="item-extra-line-roles"></div> 
            <div className="item-right-roles">
              {staff.map((rol, i) => {
                return (
                  <div className="item-right-rolpers">
                    <span key={i} className="item-right-rol">
                      {rol.roleName === "" ? <></> : rol.roleName + ""}
                      &nbsp;
                    </span>
                    <span className="item-right-pers">
                      {rol.personNameList.map((pers, i) => {
                        let string = "";
                        if (rol.personNameList.length === 1)
                          return rol.personNameList[0] + " ";
                        else {
                          switch (i) {
                            case 0:
                              string = " " + rol.personNameList[0];
                              break;
                            case rol.personNameList.length - 1:
                              string += " " + and + " " + pers;
                              break;
                            default:
                              string += ", " + pers;
                          }
                        }
                        return string;
                      })}
                    </span>
                  </div>
                );
              })}
            </div>
            <div className="item-extra-line"></div>
            <div className="item-right-item">{gender}</div>
            <div className="item-right-item">{duration}</div>
            <div className="item-right-item">{recommendedAge}</div>

            <div className="item-extra-line"></div>
            <div className="item-right-item">
              <span className="item-right-red">{langs} &nbsp;</span>
              <span className="item-right-pers">
              {idiomList.map((idiom, i) => {
                let string = "";
                if (idiomList.length === 1) return idiomList[0].idiomName;
                else {
                  switch (i) {
                    case 0:
                      string = idiomList[0].idiomName;
                      break;
                    case idiomList.length - 1:
                      string += " " + and + " " + idiom.idiomName;
                      break;
                    default:
                      string += ", " + idiom.idiomName;
                  }
                }
                return string;
              })}
              </span>
            </div>
            <div className="item-right-pers">
              {subtitleList.length >= 1 && (
                <span className="item-right-red">{texts}&nbsp; </span>
              )}
            
              {subtitleList.map((subt, i) => {
                let string = "";

                if (subtitleList.length === 1)
                  return subtitleList[0].subtitleName;
                else {
                  switch (i) {
                    case 0:
                      string = subtitleList[0].subtitleName;
                      break;
                    case subtitleList.length - 1:
                      string += " " + and + " " + subt.subtitleName;

                      break;
                    default:
                      string += ", " + subt.subtitleName;
                  }
                }
                return string;
              })}
              
            </div>
            {/* create content reladted */}
           { relatedContentList.length > 0 && <> <div className="item-extra-line"></div>
            <div className="item-right-red">{content}</div>

            {relatedContentList.map((relatedContent, i) => {
              return(
                <div className="item-right-item">
                <a className="content-related-link" target="_blank" href={`${relatedContent.url}`}>{relatedContent.title}</a>
                </div>
              )
            }
          )}
          </>}
          

          { seasonName && <div className="item-extra-line"></div>}
          {seasonName && <div className="item-right-item">{seasonName}</div>}
            <div className="item-extra-line"></div>
            <div className="item-right-share">
              <p>{share}</p>
              <div>
                <a
                  href={`https://www.facebook.com/sharer/sharer.php?u=${link};src=sdkpreparse`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    alt="logo ir facebook"
                    className="footer_option_social"
                    src={logoFb}
                  ></img>
                </a>
                <a
                  alt="logo ir twitter"
                  className="twitter-share-button"
                  href={`https://twitter.com/intent/tweet?text=${shareText}`}
                  data-size="large"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    alt="logo ir facebook"
                    className="footer_option_social"
                    src={logoTwit}
                  ></img>
                </a>
                <a
                  href={`mailto:?subject=${link}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    alt="logo ir mail"
                    className="footer_option_social"
                    src={logoEmail}
                  ></img>
                </a>
                <a
                  href={`https://www.pinterest.com/pin/create/button/?url=${link}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    alt="logo ir pinterest"
                    className="footer_option_social"
                    src={logoPint}
                  ></img>
                </a>
                {
                  <a
                    href={`https://www.linkedin.com/cws/share?url=${link}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="logo ir linkedin"
                      className="footer_option_social"
                      src={linked}
                    ></img>
                  </a>
                }
              </div>
            </div>
           { materialUrl && <> <div className="item-extra-line"></div>
            <div className="item-right-item">{extra}</div>
            <div className="item-right-item content-fixed">
              <PlayerMaterial myurl={materialUrl}></PlayerMaterial>
            </div>
            </>
            }

          </div>
        </div>
      </section>
      {/*MATERIAL COMPLEMENTARI
       <div className="item-extra">
        <div className="item-extra-line"></div>
        <div className="item-right-item">{extra}</div>
        <div className="complement-image"></div>
      </div> */}
    
    </>
  );
}

export default CardDetail;
